import React, { useState, useContext } from "react";
import ActionsContext from "common/ActionsContext";
import Modal from "common/Modal.jsx";

const InterfaceProfileSettingsHelpModal = () => {
  const [open, setOpen] = useState(false);
  const actions = useContext(ActionsContext);
  actions.recv("open-settings-help", function () {
    setOpen(true);
  });
  const doClose = () => setOpen(false);
  if (open !== true) {
    return null;
  }

  return (
    <Modal
      title="Interface Profile settings"
      onClose={doClose}
      content={() => (
        <React.Fragment>
          <p>
            Interface Profiles. Match flows in which the first packet came
            through any of the specified interfaces. For subscribers, the match
            will come from the first flow in the subscriber.
          </p>
          <ul>
            <li>
              <b>NAME</b>: Profile name.
            </li>
            <li>
              <b>INTERFACE</b>: One or many input interfaces assigned to this
              profile. Can&apos;t assign all available interfaces to a single
              profile. Can&apos;t assign interfaces already used in other
              profiles.
            </li>
          </ul>
          <p>
            Click on the <i className="material-icons valign-icon">edit</i> icon
            to edit an already configured profile entry.
          </p>
          <p>
            Click on the <i className="material-icons valign-icon">delete</i>{" "}
            icon to delete a single profile entry.
          </p>
          <p>
            Press the <i className="material-icons valign-icon">more_vert</i>{" "}
            icon and then select the <b>Add input interface...</b> option to add
            a new Interface to the profile.
          </p>
        </React.Fragment>
      )}
    />
  );
};

export default InterfaceProfileSettingsHelpModal;
